var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5202 3.94672L9.48016 7.94672C1.38682 10.6534 1.38682 15.0667 9.48016 17.7601L13.0535 18.9467L14.2402 22.5201C16.9335 30.6134 21.3602 30.6134 24.0535 22.5201L28.0668 10.4934C29.8535 5.09339 26.9202 2.14672 21.5202 3.94672ZM21.9468 11.1201L16.8802 16.2134C16.6802 16.4134 16.4268 16.5067 16.1735 16.5067C15.9202 16.5067 15.6668 16.4134 15.4668 16.2134C15.0802 15.8267 15.0802 15.1867 15.4668 14.8001L20.5335 9.70672C20.9202 9.32006 21.5602 9.32006 21.9468 9.70672C22.3335 10.0934 22.3335 10.7334 21.9468 11.1201Z",
    fill: "#0195D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSend);
export default __webpack_public_path__ + "static/media/chat-send.6b43688023f28f8fc42e238e084893a5.svg";
export { ForwardRef as ReactComponent };